var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_SHERBERT_BASE_URL } from './baseUrl';
import { ApiError, Fetcher } from './utilities/fetcher';
import { requestInitWithDefaultIfMatch } from './utilities/requestInitWithDefaultIfMatch';
import { makePollingRequest, mergeHeaders, objectToFormData, xhrProgressRequest } from './utilities';
import { convertToApiResponse } from './utilities/convertToApiResponse';
export const DEFAULT_INIT_POLLING = {
    headers: {
        prefer: 'respond-async,wait=30',
    },
};
const DEFAULT_PLACEHOLDER_ASSET = {
    body: JSON.stringify({
        type: 'other',
    }),
};
export const fetcher = Fetcher.for(DEFAULT_SHERBERT_BASE_URL);
export const setFetcherConfig = (baseUrl) => {
    fetcher.configure({
        baseUrl,
    });
};
const poll = (fn) => (...args) => __awaiter(void 0, void 0, void 0, function* () {
    const initialApiResponse = yield fn(...args);
    const { headers, signal } = args[1];
    if (!initialApiResponse.ok) {
        throw new ApiError(initialApiResponse);
    }
    if (initialApiResponse.status === 202) {
        const location = initialApiResponse.headers.get('Location');
        if (!location) {
            throw new Error('No Location header in response');
        }
        return makePollingRequest({
            url: location,
            headers,
            signal: signal !== null && signal !== void 0 ? signal : undefined,
        });
    }
    return initialApiResponse;
});
export const listAssets = fetcher.path('/v2/assets').method('get').create();
export const queryAssets = fetcher.path('/v2/assets:query').method('post').create();
export const getAsset = fetcher.path('/v2/assets/{id}').method('get').create();
export const patchAsset = poll(fetcher.path('/v2/assets/{id}').method('patch').create({
    defaultInit: requestInitWithDefaultIfMatch,
}));
export const updateAsset = fetcher.path('/v2/assets/{id}').method('put').create();
export const presignAsset = fetcher.path('/v2/assets/{id}:presign').method('post').create();
export const presignUrl = fetcher.path('/v2/assets:presign').method('post').create();
export const getMetadata = fetcher.path('/v2/assets/{id}/metadata').method('get').create();
export const getAssetLinks = fetcher.path('/v2/assets/{id}/links').method('get').create();
export const getVariantWithPolling = poll(fetcher.path('/v2/assets/{id}/{variant}').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getVariantMetadataWithPolling = poll(fetcher.path('/v2/assets/{id}/{variant}/metadata').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getMultiPageVariant = poll(fetcher.path('/v2/assets/{id}/{variant}/{pageNum}').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
/**
 * @deprecated The method should not be used Please use getImageInfoV3WithPolling
 */
export const getImageInfoWithPolling = poll(fetcher.path('/v2/assets/{id}/info/image').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getLinks = fetcher.path('/v2/links').method('get').create();
export const createLink = fetcher.path('/v2/links').method('post').create();
export const getLink = fetcher.path('/v2/links/{id}').method('get').create();
export const updateLink = fetcher.path('/v2/links/{id}').method('put').create();
export const deleteLink = fetcher.path('/v2/links/{id}').method('delete').create();
export const deleteAsset = fetcher.path('/v2/assets/{id}').method('delete').create({
    defaultInit: requestInitWithDefaultIfMatch,
});
export const hideAsset = fetcher.path('/v2/assets/{id}:hide').method('post').create({
    defaultInit: requestInitWithDefaultIfMatch,
});
export const unhideAsset = fetcher.path('/v2/assets/{id}:unhide').method('post').create({
    defaultInit: requestInitWithDefaultIfMatch,
});
export const createAssetByUriWithPolling = poll(fetcher.path('/v2/assets').method('post').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const createAssetByUriWithPollingV3 = poll(fetcher.path('/v3/assets').method('post').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getPageImageInfo = poll(fetcher.path('/v2/assets/{id}/info/image/{pageNum}').method('get').create());
export const createAssetByFileWithPolling = poll(({ body }, { signal, onProgress, headers }, params) => __awaiter(void 0, void 0, void 0, function* () {
    return xhrProgressRequest({
        body: objectToFormData(body),
        headers: mergeHeaders(DEFAULT_INIT_POLLING.headers, headers),
        signal,
        method: 'POST',
        params,
        url: `${DEFAULT_SHERBERT_BASE_URL}/v2/assets`,
        onProgress,
    }).then((response) => convertToApiResponse(response));
}));
export const createAssetByFileWithPollingV3 = poll(({ body }, { signal, onProgress, headers }, params) => __awaiter(void 0, void 0, void 0, function* () {
    return xhrProgressRequest({
        body: objectToFormData(body),
        headers: mergeHeaders(DEFAULT_INIT_POLLING.headers, headers),
        signal,
        method: 'POST',
        params,
        url: `${DEFAULT_SHERBERT_BASE_URL}/v3/assets`,
        onProgress,
    }).then((response) => convertToApiResponse(response));
}));
export const moveAsset = fetcher.path('/v2/assets/{id}:move').method('post').create();
export const createFolder = fetcher.path('/v2/folders').method('post').create();
export const getFolders = fetcher.path('/v2/folders').method('get').create();
export const getAllVersions = fetcher.path('/v2/assets/{id}/versions').method('get').create();
export const getVersionByVersionNumber = fetcher.path('/v2/assets/{id}/versions/{version}').method('get').create();
export const createAsset = fetcher.path('/v2/assets').method('post').create();
export const createPlaceholderAsset = fetcher
    .path('/v2/assets')
    .method('post')
    .create({ defaultInit: DEFAULT_PLACEHOLDER_ASSET });
export const patchAssetWithoutPoll = fetcher.path('/v2/assets/{id}').method('patch').create();
export const getDocumentItemInfoV2 = poll(fetcher.path('/v2/assets/{id}/info/documentItem').method('get').create());
//# sourceMappingURL=sherbertClient.js.map